import React, { FunctionComponent, useEffect, useState } from 'react';
import { Select, Space, Typography } from 'antd';
import { FacebookMetadata, FacebookPrivacyStatus } from '@monorepo/types';
import { useTranslation } from 'react-i18next';

const { Title } = Typography;

interface Props {
  metadata: FacebookMetadata;
  onUpdate: (metadata: Partial<FacebookMetadata>) => void;
}

const FacebookForm: FunctionComponent<Props> = ({ metadata, onUpdate }) => {
  const { t } = useTranslation();
  const [localMetadata, setLocalMetadata] =
    useState<FacebookMetadata>(metadata);

  const privacyLabels: Record<FacebookPrivacyStatus, string> = {
    [FacebookPrivacyStatus.PUBLIC]: t(
      'videoEditor.socialPublish.facebook.privacyPublic'
    ),
    [FacebookPrivacyStatus.FRIENDS]: t(
      'videoEditor.socialPublish.facebook.privacyFriends'
    ),
    [FacebookPrivacyStatus.ONLY_ME]: t(
      'videoEditor.socialPublish.facebook.privacyOnlyMe'
    ),
  };

  const handlePrivacyChange = (value: FacebookPrivacyStatus) => {
    const updated = { ...localMetadata, privacyStatus: value };
    setLocalMetadata(updated);
    onUpdate(updated);
  };

  useEffect(() => {
    setLocalMetadata(metadata);
  }, [metadata]);

  return (
    <div>
      <Space direction="vertical" style={{ width: '100%' }} size="middle">
        <div>
          <Title level={5} style={{ margin: '0px', marginBottom: '8px' }}>
            {t('videoEditor.socialPublish.facebook.privacyStatus')}
          </Title>
          <Select
            placeholder={t('videoEditor.socialPublish.common.selectPrivacy')}
            style={{ width: '100%' }}
            value={localMetadata.privacyStatus}
            onChange={handlePrivacyChange}
          >
            {Object.values(FacebookPrivacyStatus).map((privacyStatus) => (
              <Select.Option key={privacyStatus} value={privacyStatus}>
                {privacyLabels[privacyStatus]}
              </Select.Option>
            ))}
          </Select>
        </div>
      </Space>
    </div>
  );
};

export default FacebookForm;
